// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"ddbdf057","763":"ef246708"}[chunkId] + ".chunk.js";
};